import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { TRIPS } from "@/data/trips";

export default function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="bg-brand-primary text-white/85 mt-24">
      <div className="container-prose py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Link to="/" className="inline-flex items-center mb-6" aria-label="Club Amistad — Inicio">
            <span className="inline-flex bg-white rounded-2xl p-3 shadow-sm">
              <img src="/club-amistad-logo.png" alt="Club Amistad" className="h-14 w-auto" />
            </span>
          </Link>
          <p className="font-manrope text-sm md:text-base leading-relaxed text-white/75 max-w-md">
            Desde 1969 organizamos viajes de esquí en familia. Nos ocupamos de todo
            — vuelos, traslados, alojamiento a pie de pista, forfaits, clases y
            actividades — para que vosotros solo os preocupéis de disfrutar.
          </p>
          <div className="mt-8 space-y-3 text-sm">
            <div className="flex items-center gap-3"><Phone className="h-4 w-4 text-brand-accent" /> 914 020 331</div>
            <div className="flex items-center gap-3"><Mail className="h-4 w-4 text-brand-accent" /> informacion@clubamistad.com</div>
            <div className="flex items-center gap-3"><MapPin className="h-4 w-4 text-brand-accent" /> Madrid, España</div>
          </div>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-outfit text-sm uppercase tracking-[0.2em] text-white/60 mb-5">
            Viajes en familia
          </h4>
          <ul className="space-y-2.5">
            {TRIPS.map((t) => (
              <li key={t.slug}>
                <Link
                  to={`/viajes-familia-esquiar/${t.slug}`}
                  data-testid={`footer-trip-${t.slug}`}
                  className="text-white/85 hover:text-white transition-colors text-sm md:text-base"
                >
                  {t.name} · {t.dates_short}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-outfit text-sm uppercase tracking-[0.2em] text-white/60 mb-5">Enlaces</h4>
          <ul className="space-y-2.5 text-sm">
            <li><a href="/#nosotros" className="hover:text-white text-white/85">Nosotros</a></li>
            <li><a href="/#dolor" className="hover:text-white text-white/85">Qué problema resolvemos</a></li>
            <li><Link to="/blog" className="hover:text-white text-white/85">Blog</Link></li>
            <li><a href="/#contacto" className="hover:text-white text-white/85">Contacto</a></li>
          </ul>
          <h4 className="font-outfit text-sm uppercase tracking-[0.2em] text-white/60 mt-8 mb-5">Legal</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/aviso-legal" className="hover:text-white text-white/85">Aviso legal</Link></li>
            <li><Link to="/politica-de-privacidad" className="hover:text-white text-white/85">Política de privacidad</Link></li>
            <li><Link to="/politica-de-cookies" className="hover:text-white text-white/85">Política de cookies</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-prose py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-white/55">
          <p>© {new Date().getFullYear()} Club Amistad — Viajes de esquí en familia desde 1969.</p>
          <div className="flex items-center gap-4">
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("open-cookie-banner"))}
              data-testid="footer-cookie-settings"
              className="hover:text-white transition-colors underline-offset-2 hover:underline"
            >
              Configurar cookies
            </button>
            <span aria-hidden="true">·</span>
            <p>Hecho con cariño en Madrid.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
